import { SSO } from "../../common/apiUrl/sso/ssoUrl";
import { API } from "../../common/model/objectTypes";
import { organizerStatusInfo } from "../../utils/apiDescription/sso/organizerStatus";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData } from "../../utils/objectTypeConstants";
import { organizerStatusRequestParameter, organizerStatusResponseBody, updateDocumentStatusRequestBody } from "../../utils/sso/apiObjects";
import { organizerStatusJsonRequestCurl, updateDocumentStatusJsonRequestCurl } from "../../utils/sso/sampleJsonRequest";
import { organizerStatusJsonResponse } from "../../utils/sso/sampleJsonResponse";

const organizerStatus: API = {
    name: "Organizer Status",
    url: `${API_BASE_URL}/${SSO.ORGANIZER_STATUS.GET_ORGANIZER_STATUS_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: organizerStatusInfo.getOrganizerStatus,
    requestBody: organizerStatusRequestParameter,
    responseBody: organizerStatusResponseBody,
    jsonRequest: organizerStatusJsonRequestCurl,
    jsonResponse: organizerStatusJsonResponse,
}

const updateDocumentStatus: API = {
    name: "Update Document Status",
    url: `${API_BASE_URL}/${SSO.ORGANIZER_STATUS.UPDATE_DOCUMENT_STATUS_URL}`,
    method: "PUT",
    headers: commonRequestHeader,
    apiInfo: organizerStatusInfo.updateDocumentStatus,
    requestBody: updateDocumentStatusRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: updateDocumentStatusJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'Organizer Status':
            return organizerStatus;
        case 'Update Document Status':
            return updateDocumentStatus;
    }
}